var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAdFilm = function SvgAdFilm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.27588 8.46582C2.27588 7.91354 2.72359 7.46582 3.27588 7.46582H9.24499V15.1485H3.27588C2.72359 15.1485 2.27588 14.7008 2.27588 14.1485V8.46582Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.64941 15.1484H7.36958L7.76452 21.7716C7.79879 22.3463 7.34198 22.8311 6.76629 22.8311H6.04968C5.52051 22.8311 5.08295 22.4189 5.05145 21.8907L4.64941 15.1484Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3595 2.70337C22.0154 2.44632 22.7244 2.92994 22.7244 3.63442L22.7244 17.7827C22.7244 18.4502 22.0828 18.9304 21.4424 18.7421L9.25348 15.1594L9.25348 7.44785L21.3595 2.70337Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })));
};
export default SvgAdFilm;